import { render, staticRenderFns } from "./LsInfoRowFrequency.vue?vue&type=template&id=f30b76d6&scoped=true&"
import script from "./LsInfoRowFrequency.vue?vue&type=script&lang=js&"
export * from "./LsInfoRowFrequency.vue?vue&type=script&lang=js&"
import style0 from "./LsInfoRowFrequency.vue?vue&type=style&index=0&id=f30b76d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30b76d6",
  null
  
)

export default component.exports